import { combineReducers } from "redux";
import dataSelectionReducer from "./dataSelectionReducer";
import returnItemsReducer from "./returnItemsReducer";
import returnCollectionReducer from "./returnCollectionReducer";
import returnCollectionsReducer from "./returnCollectionsReducer";
import dataLayersReducer from "./dataLayersReducer";
import returnChartReducer from "./returnChartReducer";
import newJobReducer from "./newJobReducer";
import computingViewReducer from "./computingViewReducer";

// reducer import

// ==============================|| COMBINE REDUCER ||============================== //

const allReducer = combineReducers({
  dataSelection: dataSelectionReducer,
  returnItems: returnItemsReducer,
  returnCollection: returnCollectionReducer,
  returnCollections: returnCollectionsReducer,
  dataLayers: dataLayersReducer,
  returnChart: returnChartReducer,
  newJob: newJobReducer,
  computingView: computingViewReducer,
});

export default allReducer;
